import {
    UPDATE_STEP1_DATA,
    UPDATE_STEP2_DATA,
    UPDATE_STEP3_DATA,
    UPDATE_STEP4_DATA,
    UPDATE_STEP5_DATA,
    UPDATE_STEP6_DATA,
    UPDATE_STEP7_DATA,
    UPDATE_STEP7_FORM_DATA,
    UPDATE_PAYMENT_BUTTON_ID,
    UPDATE_STEP5_MARKERS,
    UPDATE_STEP5_ALL_LOCATIONS,
    UPDATE_STEP5_SELECTED_COUNTRY
} from "../../@jumbo/constants/ActionTypes";

const INIT_STATE = {
    step1Data: null,
    step2Data: null,
    step3Data: null,
    step4Data: null,
    step5Data: {},
    step6Data: null,
    step7Data: null,
    step5Markers: [],
    formData: {
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        company: "",
        street: "",
        houseNumber: "",
        postCode: "",
        location: "",
        reference: "",
        organisation_id: "",
        radio1: "0",
        radio2: "0"
    },
    paymentButtonID: "",
    localCacheSTEP5: {
        allLocations: null,
        selectedCountryCode: null
    },
    step5AllLocations: null,
    step5SelectedCountryCode: null
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case UPDATE_STEP1_DATA: {
            return {
                ...state,
                step1Data: action.payload
            }
        }
        case UPDATE_STEP2_DATA: {
            return {
                ...state,
                step2Data: action.payload
            }
        }
        case UPDATE_STEP3_DATA: {
            return {
                ...state,
                step3Data: action.payload
            }
        }
        case UPDATE_STEP4_DATA: {
            return {
                ...state,
                step4Data: action.payload
            }
        }
        case UPDATE_STEP5_DATA: {
            return {
                ...state,
                step5Data: action.payload
            }
        }
        case UPDATE_STEP6_DATA: {
            return {
                ...state,
                step6Data: action.payload
            }
        }
        case UPDATE_STEP7_DATA: {
            return {
                ...state,
                step7Data: action.payload
            }
        }
        case UPDATE_STEP5_MARKERS: {
            return {
                ...state,
                step5Markers: action.payload
            }
        }
        case UPDATE_STEP5_ALL_LOCATIONS: {
            return {
                ...state,
                step5AllLocations: action.payload
            }
        }
        case UPDATE_STEP5_SELECTED_COUNTRY: {
            return {
                ...state,
                step5SelectedCountryCode: action.payload
            }
        }
        case UPDATE_STEP7_FORM_DATA: {
            return {
                ...state,
                formData: action.payload
            }
        }
        case UPDATE_PAYMENT_BUTTON_ID: {
            return {
                ...state,
                paymentButtonID: action.payload
            }
        }
        default:
            return state
    }
}
